export const LoginEvent = {
	BOOT_STARTED: 'login.boot.started',
	AUTH_STARTED: 'login.auth.started',
	AUTH_COMPLETED: 'login.auth.completed',
	AUTH_FAILED: 'login.auth.failed',
	TRANSLATIONS_LOADED: 'login.translations.loaded',
	BOOT_COMPLETED: 'login.boot.completed',
	APP_REQUESTED: 'login.app.requested',
	APP_INITIALIZED: 'login.app.initialized',
	APP_MOUNTED: 'login.app.mounted',
	SOCKET_CONNECTED: 'login.socket.connected',
	LOBBY_LOADED: 'login.lobby.loaded',
} as const

export interface LoginAnalyticsEvent {
	name: string
	data: Record<string, unknown>
	timestamp: number
}

export type LoginAnalyticsSink = (event: LoginAnalyticsEvent) => void

const sinks: LoginAnalyticsSink[] = []
let context: Record<string, unknown> = {}
let t0: number | undefined

export function registerLoginSink(sink: LoginAnalyticsSink): void {
	sinks.push(sink)
}

export function setLoginContext(ctx: Record<string, unknown>): void {
	context = { ...context, ...ctx }
}

export function clearLoginContext(): void {
	context = {}
	t0 = undefined
}

export function emitLoginEvent(name: string, data: Record<string, unknown>): void {
	let elapsedMs: number
	if (t0 === undefined) {
		t0 = performance.now()
		elapsedMs = 0
	} else {
		elapsedMs = Math.round(performance.now() - t0)
	}
	const event: LoginAnalyticsEvent = { name, data: { ...context, ...data, elapsedMs }, timestamp: Date.now() }
	for (const sink of sinks) {
		try {
			sink(event)
		} catch (error) {
			console.error(`[login-analytics] Sink failed for ${name}`, error)
		}
	}
}

export function clearLoginSinks(): void {
	sinks.length = 0
}
